export function popProp(obj, prop) {
    let value = obj[prop];
    delete obj[prop];
    return value;
}

export function validStatus(status) {
    return status >= 200 && status < 300;
}